export default __webpack_public_path__ + "static/media/Hany Saad.381a42e3.jpg";